export const PosgraduatesDiscover = [
  {
    title:
      'Especialidad en Sistema Integral de Justicia Penal para Adolescentes (ESIJPA)',
    description:
      'Una nueva generación de líderes en procuración de justicia para adolescentes.',
    users: 300,
    img: 'https://d39ruvey39ymlc.cloudfront.net/files/images/ESIJPA_academia.jpg',
    link: 'ESIJPA'
  },
  {
    title: 'Especialidad en Evaluación Psicológica Forense (EEPF)',
    description:
      'Psicología aplicada para fortalecer el sistema de justicia.',
    users: 300,
    img: 'https://d39ruvey39ymlc.cloudfront.net/files/images/EEPF_academia.jpg',
    link: 'EEPF'
  },
  {
    title: 'Maestría en Psicología Jurídica Forense (MPJF)',
    description:
      'Una Nueva Generación de Líderes en la Psicología Jurídica Forense',
    users: 300,
    img: 'https://d39ruvey39ymlc.cloudfront.net/files/images/MPJF_academia.jpg',
    link: 'MPJF'
  }
];

export const Posgraduates = [
  {
    title:
      'Especialidad en Sistema Integral de Justicia Penal para Adolescentes (ESIJPA)',
    description:
      'Una nueva generación de líderes en procuración de justicia para adolescentes.',
    users: 300,
    img: 'https://d39ruvey39ymlc.cloudfront.net/files/images/ESIJPA_academia.jpg',
    link: 'ESIJPA'
  },
  {
    title: 'Especialidad en Evaluación Psicológica Forense (EEPF)',
    description:
      'Psicología aplicada para fortalecer el sistema de justicia.',
    users: 300,
    img: 'https://d39ruvey39ymlc.cloudfront.net/files/images/EEPF_academia.jpg',
    link: 'EEPF'
  },
  {
    title: 'Maestría en Psicología Jurídica Forense (MPJF)',
    description:
      'Una Nueva Generación de Líderes en la Psicología Jurídica Forense',
    users: 300,
    img: 'https://d39ruvey39ymlc.cloudfront.net/files/images/MPJF_academia.jpg',
    link: 'MPJF'
  },
  {
    title: 'Maestría en Derecho Procesal Penal Acusatorio (MDPPA)',
    description:
      'Formación en Legalidad y Derechos Humanos que necesita el México contemporáneo',
    users: 300,
    img: 'https://d39ruvey39ymlc.cloudfront.net/files/images/MDPPA_academia.jpg',
    link: 'MDPPA'
  },
  {
    title:
      'Maestría Ejecutiva en Evaluación Psicológica Forense (MEPF)',
    description:
      'Fórmate de manera profesional en evaluaciones psicológicas forenses e informes periciales de impacto.',
    users: 300,
    img: 'https://d1g6c01s9ssd7h.cloudfront.net/img/MEPF.jpg',
    link: 'MEPF'
  }
];
